exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advertise-availables tr td {\n  padding: 2px 5px; }\n\n.advertise-availables {\n  width: 100%; }\n", ""]);

// exports
